import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    addWidgetCta: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        opacity: 1,
        marginTop: theme.spacing(0.75),

        '& .MuiButton-root': {
            fontSize: theme.typography.size.m,
        },
    },
    halfOpacity: {
        opacity: 0.5,
    },
    textWrapper: {
        display: 'flex',
        justifyContent: 'center',

        '& .MuiTypography-h4': {
            fontWeight: theme.typography.fontWeightBold,
        },
        '& .MuiTypography-h6': {
            width: '55%',
            marginTop: theme.spacing(0.5),
            fontSize: theme.typography.size.l,

            '& span': {
                '& p': {
                    display: 'contents',
                },
            },
        },
    },
    noDataWrapper: {
        width: '100%',
        textAlign: 'center',

        '& svg': {
            width: theme.spacing(5),
            height: theme.spacing(5),
        },
    },
    noData: {
        width: '100%',
        textAlign: 'center',
    },
    noWidgetsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: theme.spacing(3),
    },
    noWidgetsImg: {
        '& img': {
            width: theme.spacing(20),
        },
        '& svg': {
            width: theme.spacing(19),
            height: theme.spacing(19),
        },
    },
    noWidgetsText: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        textAlign: 'center',
        fontSize: theme.typography.size.m,
        lineHeight: '1.5',
    },
}));
